@if (state$ | async; as state) {
  @if (state.loading) {
    <!-- two lines where the rows will stand (0127) -->
    <div class="where-used-item"><div class="where-used-item-name"><span class="shadow shadow-long"></span></div></div>
    <div class="where-used-item"><div class="where-used-item-name"><span class="shadow"></span></div></div>
  } @else if (state.items && state.items.length > 0) {
    @for (item of state.items; track item.bomItemId) {
      <a class="where-used-item" [routerLink]="['/bom', item.bomItemId]">
        <div class="where-used-item-name" [title]="item.name">{{ item.name }}</div>
        <div class="where-used-item-amount">{{ formatNumber(item.amount) }}</div>
      </a>
    }
  } @else {
    <div class="where-used-empty">Nieużywane w innych elementach</div>
  }
}
